import React, { useState, useEffect } from 'react';
import { Layout } from './Layout';
import { Divider, Header, Message, Segment } from 'semantic-ui-react';
import * as yup from 'yup';
import { userManageClient } from '../userManageClient';
import { UserProfileUpdateRequest, UserProfileResponse } from '@app/api2/api';

interface ProfileFormValues {
    phoneNumber: string;
}

export const Profile: React.FC = () => {
    const [profile, setProfile] = useState<UserProfileResponse | null>(null);
    const [loading, setLoading] = useState(true);
    const [updateError, setUpdateError] = useState<string>('');
    const [successMessage, setSuccessMessage] = useState<string>('');

    const validationSchema: yup.SchemaOf<ProfileFormValues> = yup.object().shape({
        phoneNumber: yup.string()
    });

    useEffect(() => {
        loadProfile();
    }, []);

    const loadProfile = async () => {
        try {
            setLoading(true);
            const result = await userManageClient.getProfile();
            setProfile(result);
        } catch (error) {
            console.error('Error loading profile:', error);
            setUpdateError('Error loading profile information.');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (values: ProfileFormValues) => {
        setUpdateError('');
        setSuccessMessage('');
        
        try {
            const request: UserProfileUpdateRequest = {
                phoneNumber: values.phoneNumber
            };

            const result = await userManageClient.updateProfile(request);

            if (result.success) {
                setSuccessMessage('Your profile has been updated');
                await loadProfile(); // Reload to get updated data
            } else {
                setUpdateError(result.errors?.join(', ') || 'Failed to update profile.');
            }
        } catch (error) {
            console.error('Profile update error:', error);
            setUpdateError('An error occurred while updating your profile. Please try again.');
        }
    };

    if (loading) {
        return (
            <Layout>
                {/* <Header as="h1">Manage your account</Header> */}
                <Segment loading>
                    <div style={{ height: '200px' }} />
                </Segment>
            </Layout>
        );
    }

    if (!profile) {
        return (
            <Layout>
                {/* <Header as="h1">Manage your account</Header> */}
                <Message error>
                    Unable to load profile information.
                </Message>
            </Layout>
        );
    }

    const initialValues: ProfileFormValues = {
        phoneNumber: profile.phoneNumber || ''
    };

    return (
        <Layout>
            {/* <Header as="h1">Manage your account</Header> */}
            
            <Segment>
                <Header as="h3">Profile</Header>
                <Divider />
                
                {successMessage && (
                    <Message success>
                        {successMessage}
                    </Message>
                )}

                {updateError && (
                    <Message error>
                        {updateError}
                    </Message>
                )}
{/* 
                <div style={{ marginBottom: '1rem' }}>
                    <strong>Username:</strong> {profile.username}
                </div> */}

                <div>
                    <table className="ui definition table">
                        <tbody>
                            <tr>
                                <td>{window.translation.user.name}</td>
                                <td>{profile.name}</td>
                            </tr>
                            <tr>
                                <td>{window.translation.common.emailAddress}</td>
                                <td>{profile.email}</td>
                            </tr>
                            <tr>
                                <td>{window.translation.user.role}</td>
                                <td>{profile.roles?.join(", ")}</td>
                            </tr>
                            <tr>
                                <td>{window.translation.common.labs}</td>
                                <td>{(profile.labs ?? []).map(l => l.name).join(", ")}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>

                {/* <BPForm
                    initialValues={initialValues}
                    vaildationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    hideButtons={true}
                    enableReinitialize={true}
                >
                    {(formProps) => (
                        <>
                            <AuthField
                                name="phoneNumber"
                                label="Phone number"
                                placeholder="Enter your phone number"
                            />
                            
                            <Divider />
                            
                            <BPButton 
                                type="submit" 
                                primary 
                                size="large" 
                                disabled={formProps.isSubmitting}
                                loading={formProps.isSubmitting}
                            >
                                Save
                            </BPButton>
                        </>
                    )}
                </BPForm> */}
            </Segment>
        </Layout>
    );
};